<template>
  <!-- 食事マスタ画面 -->
  <v-container>
    <v-card class='detail' flat>
      <v-row>
        <v-col cols="4" class="headerTitle headerGroup">
          <div class="buken">
            物件グループ
          </div>
          <ryou-select class="bukens" :items="dynamicItems" :itemText="'build_group_name'" :itemValue="'build_group_id'"
            v-model="select" :value="select">
          </ryou-select>
        </v-col>
        <v-col class="headerTitle headerData">
          <div>
            {{this.buildingName}}
          </div>
        </v-col>
        <v-col col="2" sm="2" class="headerTitle">
          <ryou-blue-btn :label="'提供設定'" :handlerClick="handleMealOfferUpdate" :iconCls="'mdi-pencil'"
            :disabled="btnCtrl" :dark="!btnCtrl">
          </ryou-blue-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="headerbtn">
          <ryou-blue-btn :label="'新規追加'" :handlerClick="handleMealCostAdd" :disabled="btnCtrl" :dark="!btnCtrl">
          </ryou-blue-btn>
        </v-col>
      </v-row>
      <v-form ref="tableForm" v-model="tableForm" lazy-validation>
        <ryou-table ref="ryouTable" :rowKey="rowKey" :headers="headers" :url="url" :handleEdit="handleEdit"
          :handleDelete="handleDelete" :businessKeys="businessKeys" :queryParams="queryParam" style="margin-top: 10px;">
        </ryou-table>
      </v-form>
    </v-card>

    <master-meal-insert-dialog ref="modalForm" @ok="modalFormOk" :url="url"></master-meal-insert-dialog>
    <master-meal-provide-dialog ref="modalProvide" :url="url"></master-meal-provide-dialog>
  </v-container>
</template>

<script>
  import RyouSelect from "@/components/formInput/RyouSelect.vue";
  import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
  import RyouTable from "@/components/table/RyouTable.vue";

  import MasterMealInsertDialog from "./modules/MasterMealInsertDialog.vue";
  import MasterMealProvideDialog from "./modules/MasterMealProvideDialog.vue";
  import { RyouTableMixins } from "@/mixins/RyouTableMixins";
  export default {
    name: "MasterMeal",
    mixins: [RyouTableMixins],
    components: {
      RyouSelect,
      RyouBlueBtn,
      RyouTable,
      MasterMealInsertDialog,
      MasterMealProvideDialog
    },
    data() {
      return {
        btnCtrl: true,
        rowKey: "rowIndex",
        tableForm: true,
        select: "",
        dynamicItems: [],
        businessKeys: ["build_group_id", "meal_class"],
        buildingName: "",
        headers: [
          {
            text: "IDNO",
            class: "blue lighten-2 title",
            value: "rowIndex",
            align: "center",
            width: "9%",
            sortable: true,
            groupable: false
          },
          {
            text: "物件グループ名",
            class: "blue lighten-2 title",
            value: "build_group_name",
            align: "center",
            width: "18%",
            sortable: true,
            groupable: false
          },
          {
            text: "食事区分名",
            class: "blue lighten-2 title",
            value: "meal_name",
            align: "center",
            width: "18%",
            sortable: true,
            groupable: false
          },
          {
            text: "食事単価",
            class: "blue lighten-2 title",
            value: "meal_unit_price",
            align: "center",
            width: "18%",
            sortable: true,
            groupable: false
          },
          {
            text: "税区分",
            class: "blue lighten-2 title",
            value: "code_text",
            align: "center",
            width: "18%",
            sortable: true,
            groupable: false
          },
          {
            text: "操作",
            class: "blue lighten-2 title",
            value: "actions",
            align: "center",
            width: "18%",
            sortable: false,
            groupable: false
          },
          {
            text: "",
            value: "build_group_id",
            width: "0.1%",
            type: "hidden",
            sortable: false,
            groupable: false,
            filter: this.bgFilter
          }
        ],
        url: {
          list: "/masterMeal/mealCostInitGet" + "/" + this.$store.getters.getUserId + "/" + this.$store.getters.getUserClass,
          delete: "/masterMeal/mealCostDelete",
          add: "/masterMeal/mealCostInsert",
          update: "/masterMeal/mealCostUpdate",
        },
        height: 600,
      }
    },
    created() {
      this.initData();
    },
    watch: {
      select(value) {
        if (value != null && value != "") {
          this.btnCtrl = false;
        }
        else if (value == "") {
          this.btnCtrl = true;
        }

        if (value != null) {
          let params = {
            build_group_id: value,
          }
          this.getRequest("/masterMeal/buildingNameGet", params, this.$store.getters.getUserToken).then(data => {
            this.buildingName = data.result
          });
        }
        else {
          this.buildingName = "";
        }
      }
    },
    methods: {
      initData() {
        let params = {
          userId: this.$store.getters.getUserId,
          userClass: this.$store.getters.getUserClass,
        }
        this.getRequest("/masterMeal/propertyGroupGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success) {
            this.dynamicItems = data.result;
            this.dynamicItems.push(this.select);
          }
        });
      },
      handleMealOfferUpdate() {
        this.$refs.modalProvide.add(this.select);
      },
      handleMealCostAdd() {
        this.$refs.modalForm.add(this.select);
      },
      bgFilter(value) {
        if (!this.select) {
          return true;
        }
        return value.toLowerCase().includes(this.select.toLowerCase());
      },
    }
  };
</script>

<style scoped>
  .detail {
    padding-top: 20px;
  }

  .headerTitle {
    padding-bottom: 0px;
  }

  .headerbtn {
    padding: 0px 12px;
    margin-bottom: 30px;
  }

  .buken {
    width: 150px;
    height: 60px;
    padding-top: 2%;
  }

  .bukens {
    width: 300px;
    height: 80px;
  }

  .buken,
  .bukens {
    float: left;
    box-sizing: border-box;
  }

  .headerGroup {
    padding-right: 0px;
  }

  .headerData {
    padding-left: 0px;
  }
</style>